import { useLocation, useNavigate, useParams } from "react-router-dom";
import { registerDomainType, registerUserInfoType } from "../../../../../service/types/authTypes/loginTypes";
import { useTranslation } from "react-i18next";
import * as Yup from 'yup';
import { useFormik } from "formik";
import { CForm, CTooltip } from "@coreui/react";
import { useEffect, useRef } from "react";
import { useMutation } from "react-query";
import authService from "../../../../../service/reactQueryServices/services/authService";
import packageService from "../../../../../service/reactQueryServices/services/packageService";
import { isValidHttpUrl, registerWizardStepValidating, registerWizardStorageHandling, setLoginLocalStorageProps } from "../../../../../components/helper";
import CustomValuesHookTS from "../../../../../Hooks/CustomValuesHookTS";
import RegisterPackage from "./RegisterPackage";
import { toast } from "react-toastify";
import { InformationSVG } from "../../../../../components/IconSvg";
import ToastMessage from "../../../../../components/ToastMessage";
import AddingDomainHint from "../../../../../components/AddingDomainHint";

type LocalStatesType = { isFinish: boolean, packageLoading: boolean, protocol: string }

const DomainForm = () => {
    const { mutateAsync: domainRegistration, data: domainRegistrationResult, isLoading } = useMutation("domainRegistration", authService.postDomainRegistrationService);
    const [localStates, setLocalStates] = CustomValuesHookTS<LocalStatesType>({
        isFinish: false, packageLoading: false,
        protocol: "https"
    })

    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const prevLocation = useRef(location);
    const { t, i18n } = useTranslation()
    // let direction = i18n.dir()


    const validation = Yup.object({
        domainAddress: Yup.string().test(`isValid`, t("DESCRIPTION.INVALID_URL_FORMAT") || '', function (value: any) {
            if (!value) {
                return true
            } else
                if (!isValidHttpUrl(value)) {
                    return false
                }
            return true
        })
    })

    useEffect(() => {

        const wizardStorage: any = registerWizardStepValidating(2)
        if (!wizardStorage.idValid && wizardStorage?.registerWizardStorage?.domainStep?.guidScript) {
            ToastMessage.info("ثبت نام شما انجام شده است", 7000)
            window.location.href = "/#/domain"
        }

    }, [])


    const handleToNextStep = (guidScript: string | null) => {

        registerWizardStorageHandling(2, "domainStep", { ...formik.values, guidScript: guidScript, tabId: window.history?.state?.key })

        if (params.packageId) {
            navigate(`/signup/package${params.packageId && `/${params.packageId}/${params.durationId}`}`, {
                state: {
                    ...location.state,
                    guidScript: guidScript,
                    step: 3

                }
            })

        } else {
            navigate("/signup/finish", {
                state: {
                    ...location.state,
                    guidScript: guidScript,
                    step: 3
                }
            })

        }
    }

    const handleSubmit = async (values: registerDomainType) => {

        let _values = { ...values }
        if (_values.domainAddress !== '' && !_values.name) {
            _values.name = _values.domainAddress
        }
        if (_values.domainAddress !== '') {
            _values.domainAddress = `${_values.domainAddress}`

        }
        if (!_values.domainAddress && _values.name) {
            _values.name = ''
        }

        try {

            if (_values.domainAddress) {
                const response = await domainRegistration({ ..._values, name: _values.name });

                if (response.status === 200) {
                    handleToNextStep(response.data)
                }
            } else {
                handleToNextStep(null)

            }

        } catch (error: any) {

        }

    }
    const formik = useFormik({
        validationSchema: validation,
        initialValues: {
            domainAddress: '', name: '',
        },
        onSubmit: handleSubmit,
    })


    // const handleBackStep = () => {
    //     navigate(`/signup/userInfo${params.packageId ? `/${params.packageId}/${params.durationId}` : ''}`, {
    //         state: {
    //             userInfo: { ...location.state?.userInfo },
    //             packageId: params.packageId, durationId: params.durationId,
    //         }
    //     })
    // }

    return (
        <>
            <div className='mt-3' >
                <div className="domain-address-container mb-5" style={{ minHeight: '55vh' }} >
                    <CForm onSubmit={formik.handleSubmit} >
                        <div className='mt-2 mb-2'>
                            <div className='general-page-title' >{t("ADD_DOMAIN")}</div>

                            <p>{t("DESCRIPTION.REGISTER_DOMAIN_STEP")}</p>
                        </div>

                        <div className="form-group mt-4">
                            <label htmlFor="domainAddressInput" className='d-flex flex-row justify-content-start lbl-frm' >{t('TITLES.DOMAIN_ADDRESS')}
                                {/* <i></i> */}
                                {/* <CTooltip content={t("HINTS.Domain")} placement="top">
                                <i><InformationSVG /></i>
                            </CTooltip> */}
                            </label>


                            <div className="domain-input-container" >
                                <input type='text' name="domainAddress" id="domainAddressInput"
                                    value={formik.values.domainAddress}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    autoComplete='exampleInputEmail1'
                                    className='form-control domain-input' placeholder={"domain.com"} />
                                <label>https://</label>
                            </div>
                            {formik.errors.domainAddress && formik.touched.domainAddress && <label className='label-danger '>{formik.errors.domainAddress}</label>}
                        </div>
                        <div className="form-group mt-4">
                            <label htmlFor="nameInput" className='d-flex flex-row justify-content-start lbl-frm' >{t('TITLES.DOMAIN_Name')}</label>

                            <input type='text' name="name" id="exampleInputEmail1"
                                value={formik.values.name}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                autoComplete='exampleInputEmail1'
                                className='form-control' placeholder={t('TITLES.DOMAIN_Name') || ""} />
                            {formik.errors.name && formik.touched.name && <label className='label-danger '>{formik.errors.name}</label>}
                        </div>

                    </CForm>
                    <AddingDomainHint />
                </div>


                <div className='d-flex flex-row justify-content-end'>

                    {/* <button className="btn btn-default auth-form-btn"
type="button" onClick={handleBackStep} >  {t('ACTIONS.BACK_STEP')}</button> */}


                    <button className="btn btn-primary auth-form-btn"
                        disabled={!formik.isValid || isLoading || localStates.packageLoading}
                        type="button" onClick={() => formik.handleSubmit()} >  {(isLoading || localStates.packageLoading) ?
                            <div className="spinner-border" role="status" aria-hidden="true"></div> : t('ACTION.NEXT')}</button>

                </div>

            </div>

        </>

    )
}
export default DomainForm